import { ReactComponent as AvatarImage } from "../../../assets/directtv_avatar.svg";
import { Dealer, CoopInfo } from "@/interfaces";
import { formatName } from "@/utils";
import { DealerAvatar, DealerInfo, CoopInfoItem } from "../../atoms";
import * as S from "./styles";

export type DealerExpandedInfoProps = {
  dealer?: Dealer;
  coopInfo?: CoopInfo;
};

const DealerExpandedInfo: React.FC<DealerExpandedInfoProps> = ({
  dealer = undefined,
  coopInfo = undefined,
  
  
}) => {
  console.log(dealer);
  return dealer ? (
    <S.DealerExpandedInfoContainer>
      <DealerAvatar children={<AvatarImage />} width={60} height={60} />
      <DealerInfo
        fullName={formatName(dealer?.firstName, dealer?.lastName)}
        company={dealer?.company}
        email={dealer?.email}
      />
      <S.CoopInfoContainer>
        <CoopInfoItem item={coopInfo} />
      </S.CoopInfoContainer>
    </S.DealerExpandedInfoContainer>
  ) : null;
};

export default DealerExpandedInfo;
